function createImageCdnLink(fileName) {
  const imageCdn = "https://cdn.jsdelivr.net/npm/fiver-react-assets/" || "https://fiver-react-app.s3.eu-west-2.amazonaws.com/assets/";
  return imageCdn + fileName;
}

export default createImageCdnLink;